import * as React from 'react';
import S from './Background.styles';
const Background = (props) => {
    return React.createElement(S.Background, { "aria-hidden": true, onClick: props.onClose, "data-active": props.active });
};
export default Background;
